import type { FC } from 'react';

// @ts-expect-error - CustomerStore is not typed yet
import { useCurrentCustomerId } from 'src/store/customer';

import { useMaintainCustomer } from './services/useMaintainCustomer';
import { useMaintainNotifications } from './services/useMaintainNotifications';

export const BackendDataUpdater: FC = () => {
  const customerId: string | null = useCurrentCustomerId();
  const refreshCustomer = useMaintainCustomer();
  useMaintainNotifications({ customerId, onCustomerNotifications: refreshCustomer });

  return null;
};
